var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[(_vm.currentPage == 'home')?[_c('Home')]:(_vm.currentPage == 'knowme')?[_c('KnowMe')]:(_vm.currentPage == 'gallery')?[_c('Gallery')]:(_vm.currentPage == 'contact')?[_c('Contact')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }